import { render, staticRenderFns } from "./ProductGalleryCarousel.vue?vue&type=template&id=0f380665&scoped=true&"
import script from "./ProductGalleryCarousel.vue?vue&type=script&lang=js&"
export * from "./ProductGalleryCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ProductGalleryCarousel.vue?vue&type=style&index=0&id=0f380665&lang=scss&scoped=true&"
import style1 from "./ProductGalleryCarousel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f380665",
  null
  
)

export default component.exports